<template>
  <div id="guide-share-header">
    <div class="title">{{ name }}</div>
  </div>
</template>

<script>
import Http from '../../../libs/http';

export default {
  name: 'guide-share-header',
  props: {
    name: {
      type: String,
      required: true,
      default: '',
    },
    wxaPage: {
      type: String,
      required: true,
      default: '',
    },
    wxaPageParam: {
      type: String,
      required: true,
      default: '',
    },
  },
  data() {
    return {
      qrcodeUrl: '',
    };
  },
  methods: {
    getShareQrcode() {
      const postData = {
        page: this.wxaPage,
        scene: this.wxaPageParam,
        size: 300,
      };

      Http.post('/sys/qrcode_get', postData).then((data) => {
        this.qrcodeUrl = `data:image/jpeg;base64,${data.qrcode}`;
      }).catch((e) => {
        if (e) console.log(e);
      });
    },
  },
  created() {
  },
};
</script>

<style lang="less">
#guide-share-header {
  background-color: #f7fafd;
  padding: 0 70px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 80px;
  .title {
    font-size: 22px;
    color: #333;
  }
  .share-wx {
    position: relative;
    display: flex;
    align-items: center;
    .share-btn:hover +.wx-qrcode-box {
      display: flex;
    }
    .share-btn {
      display: flex;
      align-items: center;
      cursor: pointer;
      img {
        margin-right: 5px;
      }
      span {
        font-size: 14px;
        color: #6f6f6f;
      }
    }
    .wx-qrcode-box {
      position: absolute;
      z-index: 3;
      display: none;
      flex-direction: column;
      height: 224px;
      width: 200px;
      left: 50%;
      top: 30px;
      border-radius: 4px;
      transform: translateX(-50%);
      align-items: center;
      justify-content: center;
      padding: 10px;
      background-color: white;
      box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
      &::before {
        content: '';
        position: absolute;
        top: -10px;
        left: 50%;
        transform: translate(-10px);
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-bottom: 10px solid #fff;
        z-index: 2;
      }
      &::after {
        content: '';
        position: absolute;
        top: -11px;
        left: 50%;
        transform: translate(-11px);
        border-left: 11px solid transparent;
        border-right: 11px solid transparent;
        border-bottom: 11px solid rgba(0, 0, 0, 0.1);
        z-index: 1;
      }
      .wx-qrcode-inner {
        overflow: hidden;
        background-color: #ffffff;
        position: relative;
        height: 180px;
        width: 180px;
        img {
          width: 183px;
        }
      }
      .wx-qrcode-tips {
        font-size: 14px;
        line-height: 14px;
        color: #333;
        margin-top: 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/guide/component/GuideShareHeader.vue